import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ProductListingComponent} from './product-listing/product-listing.component';
import {ProductItemComponent} from './product-item/product-item.component';
import {PipeModule} from "../../pipe/pipe.module";
import {ProductNotFoundComponent} from './product-not-found/product-not-found.component';
import {RouterModule} from '@angular/router';
import {LoaderModule} from 'src/app/loader/loader.module';
import {LAZYLOAD_IMAGE_HOOKS, LazyLoadImageModule, ScrollHooks} from 'ng-lazyload-image';
import {SkeletonProductItemComponent} from './skeleton-product-item/skeleton-product-item.component';
// import { SingleCarouselModule } from 'src/app/components-library/single-carousel/single-carousel.module';
// import { NgxImageZoomModule } from 'ngx-image-zoom';

@NgModule({
    declarations: [
        ProductListingComponent,
        ProductItemComponent,
        ProductNotFoundComponent,
        SkeletonProductItemComponent
    ],
    exports: [
        ProductListingComponent,
        ProductNotFoundComponent,
        SkeletonProductItemComponent,
    ],
    imports: [
        CommonModule,
        PipeModule,
		RouterModule,
		LoaderModule,
		LazyLoadImageModule
		// SingleCarouselModule
		// NgxImageZoomModule
    ],
	providers: [{ provide: LAZYLOAD_IMAGE_HOOKS, useClass: ScrollHooks }],
})
export class ProductListingModule { }
